export const MainMenu = {
	selectors: {
		toggle: document.querySelector(".js-main-menu--toggle"),
		submenuToggles: [
			...document.querySelectorAll(".js-main-menu--submenu-toggle"),
		],
		innerSubmenuToggles: [
			...document.querySelectorAll(".js-main-menu--inner-submenu-toggle"),
		],
		close: document.querySelector(".js-main-menu--close"),
		menu: document.querySelectorAll(".js-main-menu--menu"),
		body: document.querySelector(".js-main-menu--body"),
		dialog: document.querySelectorAll(".js-main-menu--dialog"),
		topBar: document.querySelector('.c-tk-top-bar') || document.querySelector('.c-travelking-top-bar'),
		header: document.querySelector('.c-tk-header'),
		headerHomepage: document.querySelector('.c-tk-header--sticky'),
		homepageMenu: document.querySelector('.c-tk-homepage-menu'),
		homepageSubmenuToggles: [
			...document.querySelectorAll(".c-tk-homepage-menu .js-main-menu--submenu-toggle"),
		],
	},

	init() {
		if (!this.selectors.toggle) {
			return;
		}

		this.onToggleClick = this.onToggleClick.bind(this);
		this.onSubmenuToggleClick = this.onSubmenuToggleClick.bind(this);
		this.onCloseClick = this.onCloseClick.bind(this);
		this.onAwayClick = this.onAwayClick.bind(this);

		this.selectors.toggle.addEventListener("click", this.onToggleClick);
		this.selectors.submenuToggles.forEach((submenuToggle) => {
			submenuToggle.addEventListener("click", this.onSubmenuToggleClick);
		});
		this.selectors.innerSubmenuToggles.forEach((submenuToggle) => {
			submenuToggle.addEventListener("click", this.onSubmenuToggleClick);
		});
		this.selectors.close.addEventListener("click", this.onCloseClick);
		document.addEventListener("click", this.onAwayClick);

		this.selectors.homepageSubmenuToggles.forEach(submenuToggle => {
			submenuToggle.addEventListener('click', e => {
				const activeSubmenuToggles = this.selectors.homepageMenu.querySelectorAll('.js-main-menu--submenu-toggle.is-active');

				activeSubmenuToggles.forEach(activeSubmenuToggle => {
					if (e.target === activeSubmenuToggle || activeSubmenuToggle.contains(e.target)) {
						return;
					}

					activeSubmenuToggle.classList.remove('is-active');
				})
			});
		});


		if (this.selectors.headerHomepage) {
			window.addEventListener('scroll', e => {
				const headerHeight = this.selectors.headerHomepage.clientHeight;
				const topBar = document.querySelector('.c-tk-top-bar');
				const offset = topBar ? topBar.clientHeight + headerHeight : headerHeight;

				if (window.scrollY >= offset) {
					this.selectors.headerHomepage.classList.add('is-active');
				} else {
					this.selectors.headerHomepage.classList.remove('is-active');
				}
			});
		}
	},

	onToggleClick(event) {
		event.preventDefault();

		this.toggle();
	},

	onSubmenuToggleClick(event) {
		const isDesktop = window.matchMedia("(min-width: 768px)").matches;

		const parent = event.currentTarget.closest('.c-tk-homepage-header-box');

		if (!parent && isDesktop) {
			return;
		}

		const button = event.currentTarget;
		const shouldClose = button.classList.contains("is-active");
		const content = button.nextElementSibling;
		const isAnimating = content.classList.contains("is-animating");

		if (isAnimating) {
			return;
		}

		event.preventDefault();


		const open = () => {
			content.classList.add("is-animating");
			button.classList.add("is-active");

			setTimeout(() => {
				content.style.height = `${content.scrollHeight}px`;
			}, 0);

			setTimeout(() => {
				content.classList.remove("is-animating");
				content.style.height = "";
			}, 400);
		};

		const close = () => {
			content.style.height = `${content.scrollHeight}px`;
			content.classList.add("is-animating");


			setTimeout(() => {
				content.style.height = "0px";
			}, 0);


			setTimeout(() => {
				content.classList.remove("is-animating");
				content.style.height = "";
				button.classList.remove("is-active");
			}, 400);
		};

		if (shouldClose) {
			close();
		} else {
			open();
		}
	},

	onCloseClick(event) {
		event.preventDefault();

		this.toggle(false);
	},

	onAwayClick(event) {
		const isActive = !!document.querySelector('.js-main-menu--menu.is-active');

		if (!isActive) {
			return;
		}

		const isAway =
			!event.target.closest(".js-main-menu--toggle") &&
			!event.target.closest(".js-main-menu--menu") &&
			!event.target.closest(".js-main-menu--dialog") &&
			!event.target.closest(".c-tk-header__button");

		if (isAway) {
			this.toggle(false);
		}
	},

	toggle(state) {
		this.selectors.toggle.classList.toggle("is-active", state);

		this.selectors.menu.forEach(menu => {
			menu.classList.toggle("is-active", state);
		});

		this.selectors.dialog.forEach(dialog => {
			dialog.classList.toggle("is-active", state);
		});

		if (this.selectors.toggle.classList.contains("is-active")) {
			this.scrollToTop();
		}
	},

	scrollToTop() {
		let scrollPosition = 0;

		if (this.selectors.topBar) {
			const rect = this.selectors.topBar.getBoundingClientRect();

			scrollPosition = rect.top + window.scrollY + this.selectors.topBar.clientHeight;
		}

		window.scrollTo({
			top: scrollPosition,
			behavior: 'smooth',
		});
	},
};

MainMenu.init();
